export default "__VITE_ASSET__CNruQOhW__"